import { useState } from "react";
import classnames from "classnames";
import { getBeUrl, randomStringSync } from "~/helpers/utilHelper";
import { UncontrolledTooltip } from "reactstrap";

type TUserAvatarProps = {
  id?: number | undefined;
  image?: string | null | undefined;
  initials?: string | undefined;
  size: string;
  className?: string | undefined;
  icon?: string | undefined;
  tooltip?: string | undefined;
}

const UserAvatar = ({ id, image, initials, size, className, icon, tooltip }: TUserAvatarProps) => {

  const [isImageError, setIsImageError] = useState(false);

  const imageUrl = getBeUrl(`user/${id}/${image}`);

  const canShowImage = () => !!id && !!image && !isImageError;

  const uid = randomStringSync(2);

  return <div className={classnames("user-avatar", `user-avatar-${size}`, className)} id={"usravt" + uid}>
    {canShowImage() && <img src={imageUrl} className="user-avatar-img" onError={() => setIsImageError(true)} />}
    {!canShowImage() && <div className="user-avatar-noimg bg-primary bg-soft text-primary">
      {initials && <span className="user-avatar-initials">{initials}</span>}
      {!initials && <i className={classnames("user-avatar-icon", { [icon || ""]: !!icon, "fas fa-user": !icon })}></i>}
    </div>}
    {!!tooltip && <UncontrolledTooltip placement="top" target={"usravt" + uid}>{tooltip}</UncontrolledTooltip>}
  </div>
}

export default UserAvatar;

